var map = {
	"./Mobile-rafiki.png": 4033,
	"./a1.png": 1674,
	"./a2.png": 2257,
	"./a3.png": 1128,
	"./a4.png": 3767,
	"./a5.png": 4542,
	"./a6.png": 8549,
	"./ai.png": 8178,
	"./app.png": 9483,
	"./broadcast.png": 8723,
	"./email.png": 5738,
	"./focus-amico.png": 9156,
	"./handbag.png": 6909,
	"./i1.png": 3522,
	"./i2.png": 7529,
	"./i3.png": 1776,
	"./i4.png": 7647,
	"./img1.png": 1586,
	"./img2.png": 5593,
	"./index-top.png": 16,
	"./international.png": 2950,
	"./logo.png": 3153,
	"./magic.png": 7611,
	"./mini.png": 2305,
	"./office-pana.png": 2293,
	"./one.png": 5874,
	"./phone.png": 2978,
	"./privacy.png": 3386,
	"./surgery.png": 9799,
	"./time.png": 5955,
	"./tips.png": 4798,
	"./web.png": 2540,
	"./world-amico.png": 7620,
	"./world-cuate.png": 5845,
	"./xmind.png": 3634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;